
// You can write more code here

/* START OF COMPILED CODE */

import TrapImage from "../TrapImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TrapCoconuts extends TrapImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 39.5, y ?? 38.5, texture || 'game-all', frame ?? "coconuts.png");

    // this (prefab fields)
    this.zIndex = 300;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
